let open_index = null;
 
$(document).ready(function () {
  $(".accordion-header").on("click", function () {
  const index = $(".accordion-header").index(this);
  let accordion = $(".accordion-main").eq(index),
      accordion_content = $(".accordion-content").eq(index);
    
    let childrenMargin = 0;
    accordion_content.children().map((index, item) => {
      childrenMargin += (parseInt(getComputedStyle(item).marginTop) + parseInt(getComputedStyle(item).marginBottom))
    })
    
	const height = accordion.hasClass("content-visible") ? $(this).height()
    				: accordion_content.height() + $(this).height() + 28;
    
    

    
    if (open_index != index && index != null) {
      if ($(".accordion-main").eq(open_index).hasClass("content-visible") ) {
      		animateAccordion($(this).height(), open_index);
       		let open_accordion = $(".accordion-main").eq(open_index);
        	open_accordion.find(".caret-up").toggle();
        	open_accordion.find(".caret-down").toggle();
      }
    }
    animateAccordion(height, index);
    
    $(this).find(".caret-up").toggle();
    $(this).find(".caret-down").toggle();
    
     open_index = index
    
       
    })
})

const animateAccordion = (height, index) => {
  let accordion_element = $(".accordion-main").eq(index);
  
  accordion_element.animate({height: height}, {
    duration: 300,
    complete: function () {
		accordion_element.toggleClass('content-visible');
    }
  })
	
}
